export default "__VITE_ASSET__BVqg1mNu__"